import { z } from 'zod'

export const dashboardTileFormSchema = z.object({
  tile_name: z.string().min(1, 'Tile name is required'),
  tile_description: z.string().min(1, 'Tile description is required'),
  icon_color: z.string().min(1, 'Icon color is required'),
  font_color: z.string().min(1, 'Background color is required'),
  tile_url: z.string().min(1, 'URL is required'),
  new_tab: z.boolean(),
})

export type DashboardTileFormValues = z.infer<typeof dashboardTileFormSchema>
